import { fetcher } from '@commenda/utils';

export interface CreateAndLinkAdminHubSpotCompanyParams {
  companyId: number;
  name: string;
}

export function createAndLinkAdminHubSpotCompany({
  companyId,
  name,
}: CreateAndLinkAdminHubSpotCompanyParams) {
  return fetcher(
    `admin/companies/${companyId}/external-connections/hubspot/create`,
    { method: 'POST', body: { name } }
  );
}
